import { render } from "./CompetitionListing.vue?vue&type=template&id=3930fede"
import script from "./CompetitionListing.vue?vue&type=script&lang=js"
export * from "./CompetitionListing.vue?vue&type=script&lang=js"
script.render = render

export default script